module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Heartful Business")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-authors"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#part-1-the-five-underpinning-principles"
    }
  }, [_vm._v("Part 1 – The Five\n          Underpinning Principles")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-1-greater-good-its-about-more-than-you"
    }
  }, [_vm._v("Chapter 1: Greater\n              Good – It’s About More Than You")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#seeing-through-the-lens-of-a-consumer"
    }
  }, [_vm._v("Seeing through the lens\n                  of\n                  a consumer")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-2-interdependence-we-are-all-one"
    }
  }, [_vm._v("Chapter 2:\n              Interdependence –\n              We Are All One")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#interdependence-in-organisations"
    }
  }, [_vm._v("Interdependence in\n                  organisations")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#cause-and-effect"
    }
  }, [_vm._v("Cause and effect")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#emergence-and-interdependence"
    }
  }, [_vm._v("Emergence and\n                  interdependence")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#b-corp-declaration-of-interdependence"
    }
  }, [_vm._v("B Corp Declaration of\n                  Interdependence")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-3-economy-its-way-more-than-money",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Economy –\n              It’s\n              Way More Than Money")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#shareholdersinvestors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shareholders/investors")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#new-economic-models-sharing-circular-doughnut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New economic\n                  models (sharing, circular, doughnut)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#expanded-definition-of-economy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expanded definition of\n                  economy")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-4-consciousness-you-do-have-a-soul",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4:\n              Consciousness\n              – You Do Have A Soul")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-5-ethics-and-morality-old-fashioned-concepts-that-are-more-important-than-ever",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter\n              5: Ethics and Morality – Old Fashioned Concepts That Are More Important Than Ever")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#part-2-the-five-qualities-of-conscious-leadership",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2 – The Five\n          Qualities of Conscious Leadership")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-6-purpose-is-your-north-star-shining",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Purpose\n              – Is\n              Your North Star Shining?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-7-heartful-leadership-whats-love-got-to-do-with-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter\n              7: Heartful Leadership – What’s Love Got to Do with It")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-8-presence-i-am-fully-here-right-now",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Presence\n              – I\n              Am Fully Here, Right Now")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-9-knowing-theres-more-to-life-than-facts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:\n              Knowing\n              – There’s More to Life Than Facts")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-10-intention-turbo-charging-our-will-to-good",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10:\n              Intention – Turbo-Charging Our Will to Good")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#part-3-the-five-practices",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3 – The Five Practices")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-11-reflective-practice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Reflective\n              Practice")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-12-self-awareness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Self-Awareness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-13-embracing-systems",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Embracing ‘Systems’")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#resilience-in-uncertainty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resilience in uncertainty")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#building-dialogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building dialogue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#balancing-polarities",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balancing polarities")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-14-transformational-team-working-becoming-group-conscious",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter\n              14:\n              Transformational Team Working – Becoming Group Conscious")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-15-activism-the-call-to-act",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Activism – The\n              Call\n              to Act")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-story-of-the-book",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of the Book")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0